import React from 'react'

import Image from 'next/image'
import Link from 'next/link'

import { Text } from 'Components/UI'
import { ProjectNeighborData } from 'Data/types'

import { ArrowRightGlyph } from 'Assets/Svg/Icons'

import { PROJECT } from 'Constants/Paths'

import { ArrowHolder, Container, ImageHolder, Label } from './styles'

type Props = {
  data?: ProjectNeighborData
  prev?: boolean
}

// A real anchor now (was an onClick router.push) — prev/next case pages are
// crawlable internal links.
function NextButton({ data, prev }: Props) {
  if (!data) return null

  return (
    <Container
      as={Link}
      background={data?.background?.hex}
      href={PROJECT(data.slug)}
      px={[32, 32, 32, 32, 48]}
      reverse={prev}
    >
      <Label reverse={prev}>
        <ImageHolder ml={prev ? 16 : 0} mr={!prev ? 16 : 0}>
          {data.logo?.data && (
            <Image alt={data.logo.alt ?? ''} src={data.logo.data} />
          )}

          {!data.logo?.data && data.logo?.url && (
            <Image
              alt={data.logo.alt ?? ''}
              height={100}
              src={data.logo.url}
              width={100}
            />
          )}
        </ImageHolder>

        <Text
          fontSize={[20, 20, 20, 28]}
          invertedTitle
          letterSpacing={2}
          medium
        >
          {data?.title}
        </Text>
      </Label>

      <ArrowHolder reverse={prev}>{ArrowRightGlyph()}</ArrowHolder>
    </Container>
  )
}

export default NextButton
